import { CompactUserResponse } from '../account';
import { OrgId } from '../organization';
import { TaskId } from './TaskResponse';

export type TaskLinkableId = string;

export enum LinkableModuleType {
  DEALS = 'deals',
  PROJECTS = 'projects',
  PROJECT_STEPS = 'project_steps',
  TASKS = 'tasks',
  SUPPORT_TICKETS = 'support_tickets',
  PROPOSALS = 'proposals',
  SUBSCRIPTION_BOARD_ITEMS = 'subscription_board_items',
}

export enum LinkableClassName {
  DEAL = 'Deal',
  ORGANIZATION_PROJECT = 'OrganizationProject',
  TASK = 'Task',
  SUPPORT_TICKET = 'SupportTicket',
  PROJECT_STEPS = 'ProjectStep',
  PROPOSAL = 'Proposal',
  SUBSCRIPTION_BOARD_ITEM = 'SubscriptionBoardItem',
}

export interface LinkableEntity {
  id: string;
  title: string;
  subtitle?: string;
  type: string;
  url?: string;
  value?: string;
  status?: string;
  orgId?: OrgId;
  meta: { [key: string]: any };
}

export interface TaskLinkableResponse {
  id: TaskLinkableId;
  taskId: TaskId;
  type: string;
  linkableId: string;
  linkable: LinkableEntity;
  linkedBy: CompactUserResponse;
  linkedAt: number;
}

export interface CreateTaskLinkRequest {
  taskId: TaskId;
  linkableType: LinkableClassName;
  linkableId: number;
}

export interface SearchEntityRequest {
  type: LinkableModuleType;
  search?: string;
  limit?: number;
  taskId?: TaskId;
}

export interface SearchEntityResponse {
  data: SearchEntityItem[];
}

export interface SearchEntityItem {
  id: string;
  title: string;
  subtitle?: string;
  value?: string;
}

export const MODULE_TO_CLASS_MAP: { [key in LinkableModuleType]: LinkableClassName } = {
  [LinkableModuleType.DEALS]: LinkableClassName.DEAL,
  [LinkableModuleType.PROJECTS]: LinkableClassName.ORGANIZATION_PROJECT,
  [LinkableModuleType.TASKS]: LinkableClassName.TASK,
  [LinkableModuleType.SUPPORT_TICKETS]: LinkableClassName.SUPPORT_TICKET,
  [LinkableModuleType.PROPOSALS]: LinkableClassName.PROPOSAL,
  [LinkableModuleType.PROJECT_STEPS]: LinkableClassName.PROJECT_STEPS,
  [LinkableModuleType.SUBSCRIPTION_BOARD_ITEMS]: LinkableClassName.SUBSCRIPTION_BOARD_ITEM,
};
